$(function() {
    "use strict";

    /**
     * Button Confirm.
     */
    $(".button-confirm").click(function(e) {
        e.preventDefault();
        confirm($(this));
    });

    /**
     * Button Toggle.
     */
    $(".button-toggle").click(function(e) {
        e.preventDefault();
        buttonToggle($(this));
    });

    /**
     * Chosen.
     */
    resizeChosen();
    $(window).on("resize", resizeChosen);

    /**
     * Datepicker.
     */
    datepicker();

    /**
     * Date Range Picker.
     */
    $(".daterangepicker").daterangepicker();

    /**
     * Date Time Picker.
     */
    $(".datetimepicker").datetimepicker({
        format: "d-m-Y H:i",
        theme: "dark"
    });

    /**
     * Sidebar.
     */
    initSidebar();
    $(window).on("resize", resizeSidebar);
});
